<template>
  <div class="content-container">
    <div class="d-flex loading-container">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="loader-content">
        <p>Generating your timesheet</p>
        <span class="count">You will receive an email once ready</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  title: "Timesheet",
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.content-container {
  height: 60vh;
  display: flex;
}
.loading-container {
  background-color: white;
  align-items: center;
  border-radius: 50px;
  width: 350px;
  height: 121px;
  margin: auto;

  h6 {
    font-weight: 700;
    font-size: 16px;
    line-height: 152%;
    color: #000000;
    margin-bottom: 20px;
  }
  p {
    margin-top: 5px;
    font-weight: 700;
    font-size: 16px;
    color: #000000;
    margin-bottom: 6px;
    line-height: 152%;
  }
  span.count {
    font-weight: 600;
    color: #787878;
    font-size: 14px;
    line-height: 152%;
  }
  .submit-btn {
    margin-inline-end: 0px;
  }
  .btn-text {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #ffffff;
  }
  p.reauthenticate {
    font-weight: 600;
    font-size: 14px;
    line-height: 152%;
    color: #787878;
    margin-bottom: 20px;
  }
}
.spinner-border {
  color: #103f5e;
  border-width: 0.35em;
  width: 38px;
  height: 38px;
  margin-inline-end: 22px;
  margin-inline-start: 31px;
  border-right-color: #d9d9d9;
}
.white-bg-sec {
  background-color: white;
  padding-inline-start: 30px;
  padding-top: 32px;
}
</style>
